export default __webpack_public_path__ + "static/media/27.4558c20b.png";